import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { FormControlLabel, GenericSwitch } from "components";

import { paymentMethodStatusFieldName } from "./paymentMethodConstants";

export const StatusFields = ({ isDisabled }) => {
	const { register, setValue } = useFormContext();

	const handleStatusChange = useCallback(
		({ target: { checked } }) => {
			setValue?.(paymentMethodStatusFieldName, checked);
		},
		[setValue],
	);

	return (
		<FormControlLabel
			labelEnd="Active"
			control={
				<GenericSwitch
					name={paymentMethodStatusFieldName}
					id={paymentMethodStatusFieldName}
					register={register}
					onChange={handleStatusChange}
					isDisabled={isDisabled}
				/>
			}
		/>
	);
};
